/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent, Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import moment from 'moment';

import {
  Button,
  Grid,
  Icon,
  Label,
  Modal,
  Segment,
  Table,
  Dropdown,
  Radio,
  Form,
  Loader,
} from 'semantic-ui-react';

import {
  addNewGoalInitialValues,
  addNewGoalValidationSchema,
} from '../../../../validations/addNewGoalValidation';

import {
  CustomInput,
  CustomTextArea,
  CustomCheckbox,
} from '../../../../components/form';

import {
  BrowseFile,
  CustomTable,
  EmptyContainer,
  CustomSegment,
} from '../../../../components';

import {
  cloneDeep,
  filter,
  isEmpty,
  last,
  map,
  get,
  find,
  size,
} from '../../../../utils/lodash';

import {
  createOrganizationGoal,
  deleteOrganizationGoal,
  getOrganization,
  getOrgGoals,
  getPolicies,
  getDepartmentHierarchy,
  getDepartmentLabels,
  updateOrganizationGoal,
  uploadOrgDocuments,
  postOrgDocuments,
  getOrgStrategicDocuments,
} from '../../../../store/actions';

import { DeptService } from '../../../../services';
import { ViewListModal } from '../../../../components';
import { ALLOWED_DOCUMENTS_TYPES } from '../../../../utils/constant';

import '../organization.scss';

class GoalsForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      primaryOption: null,
      secondaryOption: new Map(),
      error: null,
    };
  }

  async componentWillMount() {
    const { selectedGoal, isNew } = this.props;
    if (!isNew) {
      const secondaryOption = new Map();
      await map(selectedGoal.secondaryPolicies, (item) => {
        secondaryOption.set(item.id, true);
      });
      const disabled = false;

      await this.setState({
        primaryOption: selectedGoal.primaryPolicyId,
        secondaryOption: secondaryOption,
        isDisabled: disabled,
      });
    }
  }

  async handleValidSubmit(values) {
    const { primaryOption, secondaryOption } = this.state;
    const {
      selectedGoal,
      createOrganizationGoal,
      updateOrganizationGoal,
      resetPage,
      reportingDocumentId,
      currentPage,
      getOrgGoals,
    } = this.props;

    const lastIndex = last([...secondaryOption.keys()]);
    let secondaryPolicyId = null;
    const secondaryPolicies = map([...secondaryOption.keys()], (item) => {
      const policy = filter(this.props.policies, {
        id: item,
      });
      if (lastIndex === item) {
        secondaryPolicyId = item;
      }
      return policy[0];
    });

    values.primaryPolicyId = primaryOption;
    values.secondaryPolicyId = secondaryPolicyId;
    values.secondaryPolicies = secondaryPolicies;

    //selected documentId from dropdown
    values.goalDocumentId = reportingDocumentId;

    if (this.props.isNew) {
      await createOrganizationGoal(values);
      await getOrgGoals(currentPage, 10, reportingDocumentId);
      if (resetPage) resetPage();
    } else {
      await updateOrganizationGoal(selectedGoal.id, values);
      await getOrgGoals(currentPage, 10, reportingDocumentId);
      if (resetPage) resetPage();
    }

    this.form && this.form.reset();
    this.props.toggle();
  }
  handlePrimaryChange(value) {
    const newSecondaryOption = new Map();
    newSecondaryOption.set(1, true);
    const disabled = false;

    this.setState({
      primaryOption: value,
      error: null,
      isDisabled: disabled,
      secondaryOption: disabled ? newSecondaryOption : new Map(),
    });
  }

  async handleSecondaryChange({ target }) {
    const { secondaryOption } = this.state;
    const item = Number(target.value);
    const isChecked = target.checked;
    if (secondaryOption.get(item)) {
      await this.setState((prevState) => {
        const option = cloneDeep(prevState.secondaryOption);
        option.delete(item);
        return {
          ...prevState,
          secondaryOption: option,
        };
      });
    } else {
      await this.setState((prevState) => {
        const option = cloneDeep(prevState.secondaryOption);
        option.set(item, isChecked);
        return {
          ...prevState,
          secondaryOption: option,
        };
      });
    }
  }

  render() {
    const { account = false, toggle, selectedGoal, policies, t } = this.props;
    const { primaryOption, secondaryOption, error } = this.state;
    const defaultValue = selectedGoal;

    return (
      <Formik
        ref={(c) => (this.form = c)}
        initialValues={addNewGoalInitialValues(this.props.selectedGoal)}
        onSubmit={(values) => {
          this.handleValidSubmit(values);
        }}
        validationSchema={addNewGoalValidationSchema(t)}
      >
        {({
          handleSubmit,
          setFieldTouched,
          errors,
          touched,
          setFieldValue,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="model-space formik-custom-field-margin-bottom-zero">
              <div className=" formik-custom-field-margin-top-zero">
                <CustomInput
                  labelText={t('common.goal')}
                  className="org-inputs"
                  name="goalTitle"
                  id="goalTitle"
                />
                <small className="form-text text-muted">
                  {t('organisation.goals.form.obtain_from', {
                    type: account
                      ? t('common.account')
                      : t('common.organisation'),
                  })}
                </small>
              </div>
              <CustomTextArea
                labelText={t('formulary.goal_description')}
                className="org-inputs-textarea"
                name="goalDescription"
              />
              <small className="form-text text-muted">
                {t('organisation.goals.form.short_description')}
              </small>
            </div>
            <Table
              basic="very"
              stackable
              structured={false}
              className="org-goals-policy-table"
            >
              <Table.Header fullWidth>
                <Table.Row>
                  <Table.HeaderCell>
                    {t(
                      'organisation.goals.form.primary_policy_domain_for_goal'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    {t('common.primary')}
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    {t('common.secondary')}
                    <br />
                    {t('organisation.goals.form.optional')}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {map(policies, (item, i) => {
                  return (
                    <Table.Row
                      key={i}
                      className="formik-custom-field-margin-top-zero formik-custom-field-margin-bottom-zero "
                    >
                      <Table.Cell>
                        {t('organisation.goals.policy_name_description', {
                          policyName: item.policyName,
                          policyDescription: item.policyDescription,
                        })}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        <Radio
                          name="primaryPolicyId"
                          type="radio"
                          value={item.id}
                          checked={primaryOption === item.id}
                          onChange={() => {
                            setFieldTouched('primaryPolicyId', true);
                            setFieldValue('primaryPolicyId', item.id);
                            this.handlePrimaryChange(item.id);
                          }}
                        />
                      </Table.Cell>
                      <Table.Cell textAlign="center" className="flex-center">
                        <CustomCheckbox
                          className="check-box"
                          checked={secondaryOption.has(item.id)}
                          id={item.id}
                          name="secondaryPolicyId"
                          value={item.id}
                          onChange={(e) => this.handleSecondaryChange(e)}
                        />
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>

            <div className="error-text">
              {touched.primaryPolicyId && errors.primaryPolicyId && (
                <div className="invalid-policy">{errors.primaryPolicyId}</div>
              )}
            </div>
            <div className="model-buttons">
              <Button
                className="Secondary-Button"
                type="button"
                onClick={() => toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.save')}
                type="submit"
                className="Primary-Button"
                disabled={this.props.organization.loading}
                loading={this.props.organization.loading}
              />
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

class GoalsDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async handleGoalDelete() {
    const {
      deleteOrganizationGoal,
      selectedGoal,
      resetPage,
      currentPage,
      reportingDocumentId,
    } = this.props;

    let goalTableAPIQueryData = {
      currentPage: currentPage,
      documentId: reportingDocumentId,
    };
    await deleteOrganizationGoal(selectedGoal.id, goalTableAPIQueryData);
    if (resetPage) resetPage();
    this.toggle();
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        size="mini"
        trigger={
          <label className="table-delete-tag">{t('actions.remove')}</label>
        }
      >
        <Modal.Header>{t('organisation.goals.delete_goal_title')}</Modal.Header>
        <Modal.Content>
          <p>{t('organisation.goals.delete_goalconfirm')}</p>
        </Modal.Content>
        <Modal.Actions>
          <div className="model-buttons">
            <Button className="Secondary-Button" onClick={() => this.toggle()}>
              {t('actions.no')}
            </Button>
            <Button
              loading={this.props.organization.loading}
              disabled={this.props.organization.loading}
              onClick={() => this.handleGoalDelete()}
              className="Primary-Button"
              content={t('actions.yes')}
            />
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

class GoalsUpdate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;
    return (
      <div>
        <Modal
          trigger={
            <label className="table-edit-tag">{t('actions.edit')}</label>
          }
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="edit-a-goal"
        >
          <Modal.Header>{t('specific_actions.edit_goal')}</Modal.Header>
          <Modal.Content>
            <GoalsForm
              {...this.props}
              isNew={false}
              toggle={() => this.toggle()}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class GoalsCreate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;
    return (
      <div className="add-goal">
        <Modal
          trigger={
            <Button onClick={() => this.toggle()} className="Primary-Button">
              <Icon name="plus" />
              {t('specific_actions.add_goal')}
            </Button>
          }
          size="small"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="add-a-new-goal"
        >
          <Modal.Header>{t('specific_actions.add_goal')}</Modal.Header>
          <Modal.Content>
            <GoalsForm
              {...this.props}
              isNew={true}
              toggle={() => this.toggle()}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const NewStrategicPlan = (props) => {
  const {
    account,
    edit,
    data,
    organization: { postOrgDocLoading, updateOrgDocLoading },
    firstTimeCreation = false,
    t,
  } = props;

  const [toggle, setToggle] = useState(false);
  const [isUploadButtonClicked, setIsUploadButtonClicked] = useState(false);
  const [file, setFile] = useState('');
  const [form, setForm] = useState('');
  const [isEmpty, setEmpty] = useState(true);

  useEffect(() => {
    if (edit) {
      setForm({
        title: get(data, 'documentName', ''),
        documentId: get(data, 'organisationDocument.id', ''),
      });
      setFile(data.organisationDocument);
    }
  }, [data]);

  const handleValidSubmit = async (event, values) => {
    if (isEmpty && !edit) {
      setIsUploadButtonClicked(true);
      return;
    }
    const { uploadOrgDocuments, postOrgDocuments, currentPage } = props;

    let formData = new FormData();
    formData.set('document', file);
    formData.set('title', values.title);

    if (edit) {
      await uploadOrgDocuments(formData, form.documentId);
    } else {
      await postOrgDocuments(formData, currentPage);
    }

    setToggle(!toggle);
  };

  const onChangeFile = (file) => {
    setFile(file.file);
  };

  const isDocumentEmpty = () => {
    setEmpty(false);
  };

  return (
    <Modal
      open={toggle}
      onOpen={() => setToggle(true)}
      closeIcon={
        <div
          className="new-activity-modal-close-icon"
          onClick={() => setToggle(false)}
        >
          &times;
        </div>
      }
      size="small"
      trigger={
        <Dropdown.Item className="activity-actions-dropdown-view">
          {firstTimeCreation ? (
            <label className="activity-actions-text-native-color">
              {t('organisation.goals.create_strategic_document')}
            </label>
          ) : (
            <label className="activity-actions-text">
              {edit
                ? t('actions.edit')
                : t('organisation.goals.new_strategic_document')}
            </label>
          )}
        </Dropdown.Item>
      }
      className="organisation-strategic-document"
    >
      <Modal.Header>
        <div className="small-modal-header">
          {t('organisation.goals.strategic_plan_title')}
        </div>
      </Modal.Header>
      <Modal.Content>
        <AvForm
          className="activity-form"
          onValidSubmit={(event, values) => handleValidSubmit(event, values)}
          autoComplete="off"
          model={form}
        >
          <AvField
            className="program-activities-input"
            label={<div>{t('organisation.goals.document_title')}</div>}
            // onBlur={(e, value) => onDocumentChange(e, value)}
            name="title"
            type="text"
            validate={{
              required: {
                value: true,
                errorMessage: t('organisation.goals.document_title_required'),
              },
            }}
          />

          <BrowseFile
            label={t('organisation.goals.browse_label', {
              type: account ? t('common.account') : t('common.organisation'),
            })}
            name="strategic"
            helpMessage={t('organisation.goals.browse_help_message', {
              type: account ? t('common.account') : t('common.organisation'),
            })}
            accept={ALLOWED_DOCUMENTS_TYPES}
            buttonText={t('actions.browse')}
            mediaUpload={true}
            infoMessage={t('organisation.goals.browse_info_message')}
            setFile={onChangeFile}
            isRequiredMessage={isEmpty && isUploadButtonClicked}
            showMsg={true}
            isDocumentEmpty={isDocumentEmpty}
            placeholder={edit ? form.title : ''}
            className="media-modal-avfield"
          />
          <div className="model-buttons">
            <Button
              className="Secondary-Button"
              type="button"
              onClick={() => setToggle(!toggle)}
            >
              <div className="core-cancel-button-text">
                {t('actions.cancel')}
              </div>
            </Button>
            <Button
              type="submit"
              className="Primary-Button"
              loading={
                edit ? updateOrgDocLoading : !edit ? postOrgDocLoading : false
              }
              disabled={
                edit ? updateOrgDocLoading : !edit ? postOrgDocLoading : false
              }
            >
              <div className="core-upload-button-text">{t('actions.save')}</div>
            </Button>
          </div>
        </AvForm>
      </Modal.Content>
    </Modal>
  );
};

class GoalsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentPage: 1,
    };
  }

  columns() {
    const { t, selectedDocument } = this.props;

    return [
      {
        title: <div>{t('common.goal')}</div>,
        width: '5',
        render: (data) => {
          return (
            <label className="goals-heading">
              {data.goalTitle ? data.goalTitle : '-'}
            </label>
          );
        },
      },
      {
        title: t('common.policy_domain'),
        width: '5',
        render: (data) => {
          return (
            <div className="goals-description">
              <label className="goals-policy">
                <span className="setHeading">{t('common.primary')}</span>
                {': '}
                {data.primaryPolicyName ? (
                  <Label className="goal-labels primary" horizontal>
                    {data.primaryPolicyName}
                  </Label>
                ) : (
                  '-'
                )}
              </label>
              <label className="goals-policy">
                <span className="setHeading">{t('common.secondary')}</span>
                {': '}
                {data.secondaryPolicies
                  ? map(data.secondaryPolicies, (item, i) => {
                      return item.policyName ? (
                        <Label
                          className="goal-labels secondary"
                          key={i}
                          horizontal
                        >
                          {item.policyName}
                        </Label>
                      ) : null;
                    })
                  : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: '',
        width: '1',
        render: (data) => {
          return (
            <div>
              {!selectedDocument.isArchived && (
                <div className="goals-actions">
                  <GoalsUpdate
                    currentPage={this.state.currentPage}
                    {...this.props}
                    selectedGoal={data}
                    resetPage={() => this.resetPage()}
                  />
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: '',
        width: '1',
        render: (data) => {
          return (
            <div>
              {!selectedDocument.isArchived && (
                <div className="goals-actions">
                  <GoalsDelete
                    currentPage={this.state.currentPage}
                    {...this.props}
                    selectedGoal={data}
                    resetPage={() => this.resetPage()}
                  />
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  departmentColumns() {
    const { t, deptHierarchyFlattened, deptLabels, selectedDocument } =
      this.props;

    return [
      {
        title: t('common.goal'),
        width: '5',
        render: (data) => {
          return (
            <label className="goals-heading">
              {data.goalTitle ? data.goalTitle : '-'}
            </label>
          );
        },
      },
      {
        title: t('common.policy_domain'),
        width: '5',
        render: (data) => {
          return (
            <div className="goals-description">
              <label className="goals-policy">
                {/* <span className="setHeading">{t('common.primary')}</span>{': '} */}
                {data.primaryPolicyName ? (
                  <Label className="goal-labels primary" horizontal>
                    {data.primaryPolicyName}
                  </Label>
                ) : (
                  '-'
                )}
              </label>
              <label className="goals-policy">
                {/* <span className="setHeading">{t('common.secondary')}</span>{': '} */}
                {data.secondaryPolicies
                  ? map(data.secondaryPolicies, (item, i) => {
                      return item?.policyName ? (
                        <Label
                          className="goal-labels secondary"
                          key={i}
                          horizontal
                        >
                          {item.policyName}
                        </Label>
                      ) : null;
                    })
                  : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: DeptService.deptLabelsAsConcatenatedLabel(deptLabels),
        width: '4',
        render: (data) => {
          return (
            <>
              <div className="reference-container">
                <label>{size(data.allDepartments)}</label>
                {size(data.allDepartments) > 0 && (
                  <ViewListModal
                    title={DeptService.deptLabelsAsConcatenatedLabel(
                      deptLabels
                    )}
                    data={DeptService.orderDeptsAsPerHierarchy(
                      data.allDepartments,
                      deptHierarchyFlattened
                    )}
                    extractor={(dept) => (
                      <span className={`hierarchy level-${dept.level}`}>
                        {dept.name || '-'}
                      </span>
                    )}
                  />
                )}
              </div>
            </>
          );
        },
      },
      {
        title: '',
        width: '1',
        render: (data) => {
          return (
            <div>
              {!selectedDocument.isArchived && (
                <div className="goals-actions">
                  <GoalsUpdate
                    currentPage={this.state.currentPage}
                    {...this.props}
                    selectedGoal={data}
                    resetPage={() => this.resetPage()}
                  />
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: '',
        width: '1',
        render: (data) => {
          return (
            <div>
              {!selectedDocument.isArchived && (
                <div className="goals-actions">
                  <GoalsDelete
                    currentPage={this.state.currentPage}
                    {...this.props}
                    selectedGoal={data}
                    resetPage={() => this.resetPage()}
                  />
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  pageChange(page) {
    const { auth, getOrgGoals, reportingDocumentId } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (!isEmpty(auth.user) && auth.user.organisation) {
          getOrgGoals(page, 10, reportingDocumentId);
        }
      }
    );
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  render() {
    const {
      t,
      organization: { orgGoals, organization },
      selectedDocument,
      account,
      strategicDocuments,
    } = this.props;

    const [orgSettings] =
      organization && organization.settings
        ? organization.settings
        : [{ department: false }];

    let documentURL = get(
      selectedDocument,
      'organisationDocument.documentUrl',
      ''
    );

    return (
      <Segment
        className="content-segment"
        loading={this.props.organization.loading}
      >
        {isEmpty(strategicDocuments) ? (
          <Grid>
            <EmptyContainer
              msg={t('organisation.goals.noStrategicDocuments')}
              childrenComponent={
                <NewStrategicPlan
                  firstTimeCreation={true}
                  {...this.props}
                  account={account}
                  edit={false}
                />
              }
            />
          </Grid>
        ) : (
          <Grid>
            {/* <div className="org-goals-file-row"> */}
            <Segment className="content-segment-settings-goals">
              <Grid className="grid-padding" columns={2} divided stackable>
                <Grid.Row className="first-row">
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={8}
                    textAlign="left"
                    width={5}
                  >
                    {/* <Grid.Row> */}
                    <label className="org-title">
                      {t('organisation.goals.organisation_strategic_document')}
                    </label>
                    {/* </Grid.Row> */}
                    {documentURL && (
                      // <Grid.Row>
                      <a
                        href={documentURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="href-label"
                      >
                        <Grid.Column>
                          <Icon color="blue" name="download" />
                          <label className="org-linkLabel">
                            {selectedDocument
                              ? get(selectedDocument, 'documentName', '')
                              : ''}
                          </label>
                        </Grid.Column>
                      </a>
                      // </Grid.Row>
                    )}
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={8}
                    textAlign="right"
                  >
                    <div className="action-new">
                      <Dropdown
                        icon="ellipsis vertical"
                        direction="left"
                        inline
                        selectOnBlur={false}
                      >
                        <Dropdown.Menu>
                          <NewStrategicPlan
                            data={selectedDocument}
                            {...this.props}
                            account={account}
                            edit={true}
                          />
                          {!selectedDocument.isArchived && (
                            <NewStrategicPlan
                              data={selectedDocument}
                              {...this.props}
                              account={account}
                              edit={false}
                            />
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
            {/* </Grid.Row> */}
            <Grid.Row>
              <Grid.Column
                mobile={16}
                tablet={8}
                computer={8}
                textAlign="right"
              ></Grid.Column>
              {!selectedDocument.isArchived && (
                <Grid.Column
                  mobile={16}
                  tablet={8}
                  computer={8}
                  textAlign="right"
                >
                  <GoalsCreate
                    {...this.state}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                  />
                </Grid.Column>
              )}
            </Grid.Row>
            {orgGoals.docs && orgGoals.docs.length ? (
              <CustomTable
                header
                columns={
                  orgSettings.department
                    ? this.departmentColumns()
                    : this.columns()
                }
                data={orgGoals.docs}
                customClass="goal-table-segment"
                height={true}
                pagination
                handlePaginationChange={(page) => this.pageChange(page)}
                page={this.state.currentPage}
                noOfPages={orgGoals.pages}
                keyExtractor={(item, index) => item.id}
              />
            ) : (
              <EmptyContainer
                msg={t('organisation.goals.noGoals', {
                  type: account
                    ? t('common.account')
                    : t('common.organisation'),
                })}
              />
            )}
          </Grid>
        )}
      </Segment>
    );
  }
}

class OrganizationGoals extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentPage: 1,
      strategicDocuments: [],
      reportingDocumentId: '',
      limit: 10,
      selectedDocument: {},
    };
  }

  async componentDidUpdate(prevProps) {
    const {
      organization: { strategicDocs },
    } = this.props;
    if (strategicDocs !== prevProps.organization.strategicDocs) {
      await getOrgStrategicDocuments();

      const {
        organization: { strategicDocs },
      } = this.props;
      if (!isEmpty(strategicDocs)) {
        this.setState({
          strategicDocuments: strategicDocs,
          selectedDocument: find(
            strategicDocs,
            (d) =>
              d.strategicDocumentId === strategicDocs[0].strategicDocumentId
          ),
          reportingDocumentId: strategicDocs[0].strategicDocumentId,
        });
      }
    }
  }

  async componentDidMount() {
    const { currentPage, limit } = this.state;
    const {
      getPolicies,
      getOrgGoals,
      getOrganization,
      getOrgStrategicDocuments,
      getDepartmentHierarchy,
      getDepartmentLabels,
      auth,
    } = this.props;

    getPolicies();
    if (auth?.user?.organisation) {
      await Promise.all([
        getOrganization(auth.user.organisation.id),
        getOrgStrategicDocuments(),
        getDepartmentHierarchy(),
        getDepartmentLabels(),
      ]);
    }
    const {
      organization: { strategicDocs },
    } = this.props;

    if (!isEmpty(strategicDocs[0])) {
      let selectedDocument = find(
        strategicDocs,
        (d) => d.strategicDocumentId === strategicDocs[0].strategicDocumentId
      );
      await this.setState({
        selectedDocument: selectedDocument,
        strategicDocuments: strategicDocs,
        reportingDocumentId: strategicDocs[0].strategicDocumentId,
      });
      await getOrgGoals(
        currentPage,
        limit,
        strategicDocs[0].strategicDocumentId
      );
    }
  }

  optionArchiveYears() {
    const { t } = this.props;
    const { strategicDocuments } = this.state;

    if (isEmpty(strategicDocuments)) return;

    return map(strategicDocuments, (item, i) => ({
      key: i,
      value: get(item, 'strategicDocumentId', ''),
      text: `${moment(item.createdAt).format('YYYY MMMM')} - ${
        item.endDate === null
          ? t('common.current')
          : moment(item.endDate).format('YYYY MMMM')
      }`,
      content: (
        <div className="dropdown-content-goals">
          <div className="name-dropdown">{item.documentName}</div>
          <div className="year-dropdown">
            {moment(item.createdAt).format('YYYY MMMM')} -{' '}
            {item.endDate === null
              ? t('common.current')
              : moment(item.endDate).format('YYYY MMMM')}
          </div>
        </div>
      ),
    }));
  }

  onChangeYearSelection(event, data) {
    const { getOrgGoals } = this.props;
    const { limit, currentPage } = this.state;

    const {
      organization: { strategicDocs },
    } = this.props;

    let selectedDocument = {};
    if (!isEmpty(strategicDocs[0])) {
      selectedDocument = find(
        strategicDocs,
        (d) => d.strategicDocumentId === parseInt(data.value)
      );
    }

    this.setState(
      {
        reportingDocumentId: parseInt(data.value),
        selectedDocument,
      },
      async () => {
        try {
          await getOrgGoals(currentPage, limit, data.value);
        } catch (error) {
          throw error;
        }
      }
    );
  }

  render() {
    const { strategicDocuments, reportingDocumentId } = this.state;
    const {
      t,
      organization: { strategicLoading },
    } = this.props;

    return (
      <>
        {strategicLoading ? (
          <Loader active inline className="evaluation-div-loader" />
        ) : (
          <CustomSegment
            title={t('organisation.goals.title')}
            className="organisation-goals"
            rightHeader={
              <Grid.Column
                mobile={16}
                tablet={8}
                computer={16}
                textAlign="right"
                floated="right"
                width={8}
              >
                {!isEmpty(strategicDocuments) && (
                  <AvForm>
                    <div className="goals-dropdown-selection">
                      <Dropdown
                        placeholder={t('activity.core_data.report_year')}
                        className="archive-dropdown"
                        fluid
                        selection
                        ma
                        options={this.optionArchiveYears()}
                        direction="left"
                        value={reportingDocumentId}
                        onChange={(event, data) =>
                          this.onChangeYearSelection(event, data)
                        }
                      />
                    </div>
                  </AvForm>
                )}
              </Grid.Column>
            }
            children={
              <GoalsTable
                selectedDocument={this.state.selectedDocument}
                strategicDocuments={strategicDocuments}
                reportingDocumentId={reportingDocumentId}
                {...this.props}
              />
            }
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    policies: state.extra.policies,
    helpTips: state.extra.activityHelpTips,
    deptHierarchy: state.organization.deptHierarchy,
    deptHierarchyFlattened: state.organization.deptHierarchyFlattened,
    deptLabels: state.organization.deptLabels,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrganization,
      getPolicies,
      getOrgGoals,
      getDepartmentHierarchy,
      getDepartmentLabels,
      createOrganizationGoal,
      updateOrganizationGoal,
      deleteOrganizationGoal,
      uploadOrgDocuments,
      postOrgDocuments,
      getOrgStrategicDocuments,
    },
    dispatch
  );
};

OrganizationGoals = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationGoals);

OrganizationGoals = withTranslation()(OrganizationGoals);

export { OrganizationGoals };
